var map = {
	"../pages/demo/demo.module": [
		194
	],
	"../pages/fight-form/fight-form.module": [
		230
	],
	"../pages/fight/fight.module": [
		227
	],
	"../pages/finger-basic/finger-basic.module": [
		228
	],
	"../pages/finger-big-friend-minus/finger-big-friend-minus.module": [
		231
	],
	"../pages/finger-big-friend-mix/finger-big-friend-mix.module": [
		229
	],
	"../pages/finger-big-friend-plus/finger-big-friend-plus.module": [
		232
	],
	"../pages/finger-board/finger-board.module": [
		235
	],
	"../pages/finger-exam/finger-exam.module": [
		233
	],
	"../pages/finger-flash-card/finger-flash-card.module": [
		234
	],
	"../pages/finger-little-friend-minus/finger-little-friend-minus.module": [
		238
	],
	"../pages/finger-little-friend-mix/finger-little-friend-mix.module": [
		236
	],
	"../pages/finger-little-friend-plus/finger-little-friend-plus.module": [
		239
	],
	"../pages/finger-plus-minus/finger-plus-minus.module": [
		237
	],
	"../pages/forgot-reset/forgot-reset.module": [
		240
	],
	"../pages/forgot/forgot.module": [
		241
	],
	"../pages/home/home.module": [
		242
	],
	"../pages/login/login.module": [
		245
	],
	"../pages/profile/profile.module": [
		244
	],
	"../pages/register/register.module": [
		243
	],
	"../pages/soroban-add-sub-add-sub-so-am/soroban-add-sub-add-sub-so-am.module": [
		246
	],
	"../pages/soroban-add-sub-add-sub-so-thap-phan/soroban-add-sub-add-sub-so-thap-phan.module": [
		247
	],
	"../pages/soroban-add-sub-add-sub/soroban-add-sub-add-sub.module": [
		248
	],
	"../pages/soroban-add-sub-board/soroban-add-sub-board.module": [
		249
	],
	"../pages/soroban-basic-basic/soroban-basic-basic.module": [
		251
	],
	"../pages/soroban-basic-big-friend-minus/soroban-basic-big-friend-minus.module": [
		250
	],
	"../pages/soroban-basic-big-friend-mix/soroban-basic-big-friend-mix.module": [
		257
	],
	"../pages/soroban-basic-big-friend-plus/soroban-basic-big-friend-plus.module": [
		252
	],
	"../pages/soroban-basic-board/soroban-basic-board.module": [
		253
	],
	"../pages/soroban-basic-flash-card/soroban-basic-flash-card.module": [
		254
	],
	"../pages/soroban-basic-little-friend-minus/soroban-basic-little-friend-minus.module": [
		255
	],
	"../pages/soroban-basic-little-friend-mix/soroban-basic-little-friend-mix.module": [
		256
	],
	"../pages/soroban-basic-little-friend-plus/soroban-basic-little-friend-plus.module": [
		258
	],
	"../pages/soroban-basic-plus-minus/soroban-basic-plus-minus.module": [
		262
	],
	"../pages/soroban-board/soroban-board.module": [
		260
	],
	"../pages/soroban-divison-board/soroban-divison-board.module": [
		261
	],
	"../pages/soroban-divison-one/soroban-divison-one.module": [
		259
	],
	"../pages/soroban-divison-three/soroban-divison-three.module": [
		265
	],
	"../pages/soroban-divison-two/soroban-divison-two.module": [
		264
	],
	"../pages/soroban-exam/soroban-exam.module": [
		263
	],
	"../pages/soroban-multi-board/soroban-multi-board.module": [
		266
	],
	"../pages/soroban-multi-five/soroban-multi-five.module": [
		268
	],
	"../pages/soroban-multi-four/soroban-multi-four.module": [
		267
	],
	"../pages/soroban-multi-one/soroban-multi-one.module": [
		273
	],
	"../pages/soroban-multi-six/soroban-multi-six.module": [
		269
	],
	"../pages/soroban-multi-three/soroban-multi-three.module": [
		271
	],
	"../pages/soroban-multi-two/soroban-multi-two.module": [
		270
	],
	"../pages/training/training.module": [
		275
	],
	"../pages/video-detail/video-detail.module": [
		272
	],
	"../pages/video-list/video-list.module": [
		274
	],
	"../pages/video-shop/video-shop.module": [
		276
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 193;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 193
// module chunks = 0